import { Box, Card, CardContent, Grid, Skeleton, Stack } from "@mui/material";

function TeamMemberCardSkeleton() {
  return (
    <Card
      elevation={1}
      sx={{
        boxShadow: "0 0 6px #7faee052",
        padding: "12px !important",
      }}
    >
      <CardContent sx={{ padding: "0px !important" }}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Skeleton variant="circular" width={38} height={38} />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width="70%" height={22} />
            <Skeleton variant="text" width="90%" height={18} />
          </Box>
          <Skeleton variant="circular" width={28} height={28} />
        </Stack>
        <Stack direction="row" spacing={1} sx={{ mt: 1.5 }}>
          <Skeleton variant="rounded" width={72} height={22} sx={{ borderRadius: 1 }} />
          <Skeleton variant="rounded" width={88} height={22} sx={{ borderRadius: 1 }} />
        </Stack>
      </CardContent>
    </Card>
  );
}

export default function TeamPageSkeleton({ count = 6 }: { count?: number }) {
  return (
    <Grid container spacing={0}>
      {Array.from({ length: count }).map((_, i) => (
        <Grid item xs={12} md={6} xl={4} key={i} sx={{ mb: 3, pr: { md: 1.5 } }}>
          <TeamMemberCardSkeleton />
        </Grid>
      ))}
    </Grid>
  );
}
